import React, {
    useState, useEffect, useContext
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@ferris/react';
import { ButtonType } from '@ferris/react/components/button/Button';
import { DomUtilsCtx } from '../../../contexts/domUtils';

function LypCta({
    lypCtaText,
    display
}) {
    if (!display) return null;
    const [isBedPage, setIsBedPage] = useState(false);
    const { goToLypForm, isLypFormVisible } = useContext(DomUtilsCtx);

    useEffect(() => {
        const { pathname } = window.location;
        const isList = pathname.endsWith('list') || pathname.endsWith('list/');
        setIsBedPage(isList);
    }, []);
    return (
        <div className={classNames('lyp-cta-container', {
            visible: !isLypFormVisible,
            'hide-sticky': !isBedPage
        })}
        >
            <Button
                classes={classNames('lyp-cta')}
                data-wdio="lyp-cta"
                htmlButtonType="button"
                type={ButtonType.PRIMARY}
                id="lypCta"
                onClick={goToLypForm}
            >
                {lypCtaText}
            </Button>
        </div>
    );
}

LypCta.propTypes = {
    lypCtaText: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired
};

export default LypCta;
